import React from "react";
import { useHistory } from "react-router-dom";
//Material imports
import Email from "@material-ui/icons/Email";
import Create from "@material-ui/icons/Create";
import Person from "@material-ui/icons/Person";
import PhoneIphone from "@material-ui/icons/PhoneIphone";
import { makeStyles } from "@material-ui/core/styles";
//Limitless imports
import { useCustomerContext, useCustomerMessageContext } from "@limitless/customer/hooks";
import { InputField, SubmitButton } from "@limitless/customer/components";
import { ClientContext } from "@limitless/common/utils";
import { useMobileDetectionContext } from "../../hooks/mobile-detection/MobileDetectionContext";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginLeft: 20,
        marginRight: 20,
        marginTop: 10
    }
});

const getNumberOfRows = isMobile => {
    if (ClientContext._userMobileEnabled === "true") {
        return 1;
    }

    return isMobile ? 2 : 3;
};

const CreateMessageForm = () => {
    const { isMobileDevice } = useMobileDetectionContext();
    const numberOfRows = getNumberOfRows(isMobileDevice);
    const { updateCustomer, customer, getCustomerData } = useCustomerContext();
    const { name, email, question, mobileNumber, isFormInvalid, fieldErrors } = customer;
    const { message, createMessage } = useCustomerMessageContext();
    const { loading } = message;
    const classes = useStyles();
    const history = useHistory();

    const handleSubmit = () => {
        createMessage(getCustomerData(), newMsg => {
            history.push(`/conversation/${newMsg.messageId}/${newMsg.accessKey}/${false}`);
        });
    };

    const renderMobileTxt = () => {
        return (
            <InputField
                label="Mobile"
                icon={<PhoneIphone style={{ paddingBottom: 5, paddingLeft: 2 }} />}
                toolTipTitle="Add your mobile number"
                errorMessage={fieldErrors.mobileNumber}
                onChangeHandle={value => updateCustomer("mobileNumber", value)}
                loading={loading}
                value={mobileNumber.value}
                noGutterBottom
            />
        );
    };

    const shouldRenderMobileField = ClientContext._userMobileEnabled === "true" ? true : false;

    return (
        <div className={classes.container}>
            <InputField
                label="Name"
                icon={<Person style={{ paddingLeft: 4 }} />}
                toolTipTitle="Who the ambassador should address"
                errorMessage={fieldErrors.name}
                onChangeHandle={value => updateCustomer("name", value)}
                loading={loading}
                value={name.value}
            />
            <InputField
                label="Email"
                icon={<Email style={{ paddingLeft: 4 }} />}
                toolTipTitle="Receive email notifications about responses"
                errorMessage={fieldErrors.email}
                onChangeHandle={value => updateCustomer("email", value)}
                loading={loading}
                value={email.value}
            />
            {shouldRenderMobileField && renderMobileTxt()}
            <InputField
                label="Question"
                icon={<Create style={{ paddingLeft: 4 }} />}
                toolTipTitle="Add as much detail as possible"
                errorMessage={fieldErrors.question}
                onChangeHandle={value => updateCustomer("question", value)}
                loading={loading}
                value={question.value}
                multiline={!shouldRenderMobileField}
                rows={numberOfRows}
            />

            <SubmitButton
                disabled={loading || isFormInvalid}
                title="Submit Your Question"
                handleSubmit={handleSubmit}
                loading={loading}
            />
        </div>
    );
};

export default CreateMessageForm;
